import React, { memo } from "react";
import { Query_Imgix } from "../../../../api/imgix/index";
import BaseVideoTagWrapper from "@/components/BaseWrappers/BaseVideoTagWrapper";
import { PostData } from "../../types/singlePostsProps";
import { Box, Text } from "@radix-ui/themes";

const UserPost: React.FunctionComponent<{ data: PostData }> = ({ data }) => {
  const dataToRender = data.type.includes("shared")
    ? data.additionalData
    : data;
  try {
    return (
      <>
        {dataToRender &&
        (dataToRender.postPhoto ||
          dataToRender.postVideo ||
          dataToRender.postText) ? (
          <Box>
            {dataToRender.postPhoto && (
              <img
                alt=""
                style={{ maxWidth: "100%", height: "auto" }}
                src={
                  dataToRender.postPhoto.includes("wog.imgix") ||
                  dataToRender.postPhoto.includes("iplay.imgix")
                    ? `${dataToRender.postPhoto}?${Query_Imgix.getImgixUrlProps(
                        {
                          w: "836",
                        }
                      )}`
                    : dataToRender.postPhoto
                }
              />
            )}
            {dataToRender.postVideo && (
              <BaseVideoTagWrapper videoSrc={dataToRender.postVideo} />
            )}
          </Box>
        ) : (
          ""
        )}
      </>
    );
  } catch (error) {
    <Text size="2" color="gray">
      Failed to load post, it might no longer be available.
    </Text>;
  }
};

export default memo(UserPost);
